import * as v from "valibot";

// request
export const RequestSchema = v.object({
  ClusterId: v.string(),
  MachineIds: v.array(v.string()),
  ScaleDownDisabled: v.nullish(v.boolean()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const DataSchema = v.object({
  MachineIds: v.nullish(v.array(v.string())),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
